// Shared by React and the initial server HTML, so both request the same images.
function imageUrl(src, width) {
  if (!/^https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/(?!s--)/.test(src || '')) return src;
  return src.replace('/image/upload/', `/image/upload/f_auto,q_auto,c_limit,w_${width}/`);
}

function photoSource(photo, sizes = '(min-width: 768px) 480px, calc(100vw - 32px)') {
  const width = photo.width > 0 && photo.height > 0 ? photo.width : 4;
  const height = photo.width > 0 && photo.height > 0 ? photo.height : 3;
  const maximum = width > 4 ? Math.min(width, 1920) : 1920;
  const candidates = [...new Set([320, 640, 960, 1280, 1920].filter(w => w < maximum).concat(maximum))];
  const src = imageUrl(photo.image_url, Math.min(960, maximum));
  return {
    src, width, height, sizes,
    srcSet: src !== photo.image_url ? candidates.map(w => `${imageUrl(photo.image_url, w)} ${w}w`).join(', ') : undefined,
  };
}

module.exports = { imageUrl, photoSource };
